import { Box, Card, IconButton, Typography } from '@mui/material';
import { _Tokens } from '../../types';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import SearchIcon from '@mui/icons-material/Search';
import React, { Fragment } from 'react';
import { iconTokens } from 'libs/constans';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { changePopupStep, changePopupTokenSelected, popupSelector, setPrevStep } from './popupSlice';
import { walletStepEnum, tokenActionTypeEnum } from '../../libs/constans';

export default function SelectToken({ tokens }: { tokens: _Tokens[] }) {
    return (
        <Fragment>

            <WalletNav title="Select Token" />

            <TokenList tokens={tokens} />

        </Fragment>
    );
}
export function TokenList({ tokens }: { tokens: _Tokens[] }) {
    return (
        <Fragment>
            <Box mt={2}>
                {tokens && tokens.map((item, index) => (

                    <TokenItem key={index} item={item} />

                ))
                }
            </Box>
        </Fragment>
    )
}

const styles = {
    background: `linear-gradient(90deg, #BF26E6 -5.41%, #3C14DA 100%)`,
    borderRadius: '16px',
    textAlign: 'center',
    marginBottom: '16px',
    padding: '2px'
} as const;

const styles_box = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#1E2336',
    borderRadius: '16px',
    cursor: 'pointer',
} as const;

export function TokenItem({ item }: { item: _Tokens }) {

    const dispatch = useAppDispatch();
    const { action, ratio } = useAppSelector(popupSelector);

    if (!item) {
        return <></>
    }

    const handleSelect = () => {
        dispatch(setPrevStep(walletStepEnum.SELECT_TOKEN));
        dispatch(changePopupTokenSelected(item))
        dispatch(changePopupStep(action === tokenActionTypeEnum.SEND ? walletStepEnum.SEND_TOKEN : walletStepEnum.RECEIVE_TOKEN))
    }

    const amountUSDTString = (parseFloat(item.balance) * ratio[item.symbol]).toFixed(2);

    return (
        <Fragment>
            <Card sx={styles}>
                <Box p={2} sx={styles_box} onClick={handleSelect}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <Box sx={{ mr: 1.5 }}>
                            <object data={iconTokens[item.symbol]} width={42} height={42}> </object>
                        </Box>
                        <Box>
                            <Typography>{item.symbol}</Typography>
                        </Box>
                    </Box>
                    <Box sx={{ textAlign: 'right' }}>
                        <Typography sx={{ fontSize: '14px' }}>{item.balance}&nbsp;{item.symbol}</Typography>
                        <Typography sx={{ fontSize: '14px', color: '#D68DDE' }}>{`$`}{amountUSDTString}</Typography>
                    </Box>

                </Box>
            </Card>
        </Fragment>
    )
}

export function WalletNav({ title }: { title: string }) {
    const dispatch = useAppDispatch()

    const handleBack = () => {
        dispatch(changePopupStep(1))
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
            <IconButton onClick={handleBack}>
                <KeyboardBackspaceIcon />
            </IconButton>
            <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{title}</Typography>
            <IconButton>
                <SearchIcon />
            </IconButton>
        </Box>
    );
}